<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>分销商</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form ref="artFrom" :model="tableFrom" :label-width="labelWidth" :label-position="labelPosition" @submit.native.prevent>
                        <Row type="flex">
                            <Col v-bind="grid">
                                <FormItem label="分销商ID：" label-for="user_id">
                                    <Input size="default" enter-button placeholder="分销商ID" clearable v-model="tableFrom.user_id"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="分销商姓名：" label-for="order_no">
                                    <Input size="default" enter-button placeholder="分销商姓名" clearable v-model="tableFrom.real_name"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="分销商手机号：" label-for="mobile">
                                    <Input size="default" enter-button placeholder="分销商手机号" clearable v-model="tableFrom.mobile"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="备注：" label-for="remark">
                                    <Input size="default" enter-button placeholder="" clearable v-model="tableFrom.remark"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="分销商等级：" label-for="level_id">
                                    <Select v-width="200" v-model="tableFrom.level_id"  element-id="level_id">
                                        <Option v-for="item in levelList" :value="item.level_id" :key="item.level_id">{{ item.name }}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24" class="search">
                                <FormItem>
                                    <Button type="primary" icon="ios-search" @click="userSearchs">搜索</Button>
                                    <Button class="ml20" type="success" @click="excelOut">导出</Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <Table class="mt25" :columns="columns" :data="tableData">
                        <template slot-scope="{ row, index }" slot="avatars">
                            <viewer>
                                <div class="tabBox_img">
                                    <img :src="row.user.avatar" />
                                </div>
                            </viewer>
                        </template>
                        <template slot-scope="{ row, index }" slot="referee">
                            <div class="">{{row.referee_id ? row.referee.real_name : ''}}</div>
                            <div class="">{{row.referee_id ? row.referee.mobile : ''}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="level">
                            <div class="">{{row.level ? row.level.name : ''}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="money_rate">
                            <div class="">一级：{{row.level ? row.level.first_money : ''}}</div>
                            <div class="">二级：{{row.level ? row.level.second_money : ''}}</div>
                            <div class="">三级：{{row.level ? row.level.third_money : ''}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="first_money">
                            <div class="">{{row.level ? row.level.first_money : ''}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="second_money">
                            <div class="">{{row.level ? row.level.second_money : ''}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="third_money">
                            <div class="">{{row.level ? row.level.third_money : ''}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="first_child_num">
                            <router-link :to="{path: '/Member/MemberList.html', query: {referee_id: row.user_id}}" class="">{{row.first_child_num}}</router-link>
                        </template>
                        <template slot-scope="{ row, index }" slot="action">
                            <router-link :to="{path: '/app/dealer/order.html', query: {user_id: row.user_id}}" class="">
                                <el-button size="mini" type="danger">分销订单</el-button>
                            </router-link>
                            <router-link :to="{path: '/Member/MemberList.html', query: {referee_id: row.user_id}}" class="">
                                <el-button size="mini" class="ml10" type="danger">下级</el-button>
                            </router-link>
                            <el-button size="mini" type="primary" class="ml10" @click="edit(row)">编辑</el-button>
                        </template>
                        <template slot-scope="{ row, index }" slot="money">
                            <div class="">当前佣金：{{row.money}}</div>
                            <div class="">已提现佣金：{{row.total_money}}</div>
                            <div class="">冻结佣金：{{row.freeze_money}}</div>
                        </template>
                    </Table>
                    <div class="acea-row row-right page">
                        <Page
                                :total="total"
                                :current="tableFrom.page"
                                show-elevator
                                show-total
                                @on-change="pageChange"
                                :page-size="tableFrom.limit"/>
                    </div>
                </Card>
            </div>
        </div>
        <el-dialog title="编辑" :visible.sync="dialogFormVisible">
            <el-form label-position="right" :model="form" label-width="auto">
                <el-form-item label="真实姓名">
                    <el-input clearable v-model="form.real_name" placeholder="请输入真实姓名"/>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input clearable v-model="form.mobile" placeholder="请输入手机号"/>
                </el-form-item>
                <el-form-item label="推荐人">
                    <div class="picBox" @click="changeUser">
                        <div class="pictrue dis-flex flex-x-center flex-dir-column flex-y-center" v-if="form.referee">
                            <div>
                                {{form.referee.real_name}}
                            </div>
                            <div>[{{form.referee.user_id}}]</div>
                        </div>
                        <div class="upLoad acea-row row-center-wrapper" v-else>
                            <Icon type="ios-camera-outline" size="26" class="iconfonts"/>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input clearable v-model="form.remark" placeholder=""/>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="submit">提交</el-button>
            </div>

        </el-dialog>
        <!-- 选择商品-->
        <el-dialog title="分销商列表" :visible.sync="dealerUserModals" width="1000px" @on-cancel="cancel">
            <dealerUserList ref="dealerUserList"  @getUser="getUser"></dealerUserList>
        </el-dialog>
    </div>
</template>

<script>
    import dealerUserList from '@/components/dealerUserList/index';

    import second from "../second.vue";
    export default {
        name: "index",
        components: { second, dealerUserList },
        computed: {
            labelWidth () {
                return 120;
            },
            labelPosition () {
                return 'right';
            }
        },
        watch: {
            $route: function (e) {
                this.tableFrom.pid = e.query.id
                this.getList();
            }
        },
        data () {
            return {
                grid: {
                    xl: 10,
                    lg: 10,
                    md: 12,
                    sm: 24,
                    xs: 24,
                },
                isLoad: false,
                columns: [
                    {
                        title: 'ID',
                        key: 'user_id',
                        width: 60,
                    },
                    {
                        title: "头像",
                        slot: "avatars",
                        width: 60,
                    },
                    {
                        title: "真实姓名",
                        key: "real_name",
                        width: 120,
                    },
                    {
                        title: "手机号",
                        key: "mobile",
                        width: 120,
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: 150,
                    },
                    {
                        title: "上级分销商",
                        align: 'center',
                        slot: "referee",
                        width: 100,
                    },
                    {
                        title: '分销等级',
                        slot: 'level',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: '分销比例 (%)',
                        slot: 'money_rate',
                        align: "center",
                        minWidth: 120,
                    },
                    {
                        title: '佣金账户',
                        slot: 'money',
                        align: "center",
                        minWidth: 100,
                    },
                    {
                        title: '推广用户数',
                        slot: 'first_child_num',
                        align: "center",
                        width: 90,
                    },
                    {
                        title: '添加时间',
                        key: 'create_time',
                        align: "center",
                        width: 180,
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        align: "center",
                        minWidth: 270,
                    },
                ],
                tableFrom: {
                    page: 1,
                    limit: 15,
                    pid: this.$route.query.id ? this.$route.query.id : 0
                },
                total: 0,
                tableData: [],
                loading: false,
                levelList: [],
                dialogFormVisible: false,
                form: {},
                dealerUserModals: false
            }
        },
        created() {
        },
        mounted () {
            this.getList();
            this.getLevelList()
        },
        methods: {
            // 列表
            getLevelList () {
                this.loading = true;
                this.axios.post('/store/app.dealer.level/list', {})
                    .then(async (res) => {
                        if (res.code == 1) {
                            let data = res.data.list
                            this.levelList = data;
                        }
                    })
                    .catch((res) => {
                        this.loading = false;
                    });
            },
            pageChange(index) {
                this.tableFrom.page = index;
                this.getList();
            },
            // 列表
            getList () {
                this.loading = true;
                this.axios.post('/store/app.dealer.user/list', this.tableFrom)
                .then(async (res) => {
                    if (res.code == 1) {
                        let data = res.data.list
                        this.tableData = data.data;
                        this.total = data.total;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                });
            },
            // 表格搜索
            userSearchs() {
                this.tableFrom.page = 1;
                this.getList();
            },
            edit: function (row) {
                this.form = {
                    user_id: row.user_id,
                    real_name: row.real_name,
                    mobile: row.mobile,
                    remark: row.remark,
                    referee_id: row.referee_id,
                    referee: row.referee
                }
                this.dialogFormVisible = true
            },
            submit: function () {
                this.loading = true;
                this.axios.post('/store/app.dealer.user/edit', Object.assign({}, this.form))
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$message.success(res.msg)
                        this.getList()
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            },
            changeUser () {
                this.dealerUserModals = true;
            },
            cancel: function () {
                this.dealerUserModals = false;
            },
            getUser: function (row) {
                this.form.referee_id = row.user_id
                this.form.referee = row
                this.cancel()
                console.log(row)
            },
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/store/app.dealer.user/export', this.tableFrom)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '分销商导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        }
    }
</script>

<style scoped>

</style>
